import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import StyledDataList from './DataList.style';

const renderItem = (item, idx) => {
  let ID = '';
  // expecting intl object to have id props
  if (typeof item.title === 'object' && item.title.props) {
    ID = item.title.props.id;
    // normal string case
  } else if (typeof item.title === 'string') {
    ID = item.title.replace(/\W/g, '');
  }

  return (
    <Fragment key={`dl${idx}${ID}`}>
      <dt>{item.title}</dt>
      <dd data-qa={item.qa}>{item.data}</dd>
    </Fragment>
  );
};

const DataList = ({ list, theme }) => {
  const listCSS = cn(
    'datalist',
    theme ? theme.map(css => `datalist--${css}`).join(' ') : ''
  );
  if (list) {
    return (
      <StyledDataList className={listCSS}>
        {list.map(renderItem)}
      </StyledDataList>
    );
  } else {
    return null;
  }
};

DataList.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      data: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.number
      ]),
      qa: PropTypes.string
    })
  ),
  theme: PropTypes.arrayOf(PropTypes.string)
};
export default DataList;



// WEBPACK FOOTER //
// ./src/components/DataList/DataList.js